import React, { useState } from 'react';
import Logo from '../../../assets/imgs/logo_mig.png'
import { useAuth } from '../../../hooks/useAuth';
import { useNavigate } from 'react-router-dom'

export default function Login() {
  const [email, setEmail] = useState('')
  const [pass, setPass] = useState('')
  const [erro, setErro] = useState(false)
  const [desabilitado, setDesabilitado] = useState(false)

  const nav = useNavigate()
  const auth = useAuth()

  const handleSubmit = (e) => {
    e.preventDefault()
    setDesabilitado(true)

    auth.logar(email, pass)
      .then(() => {
        setDesabilitado(false)
        nav("/relatos")
      })
      .catch(e => {
        setDesabilitado(false)
        setErro(true)
      })
  }

  return (
    <div className="w-screen h-screen bg-primary flex items-center justify-center">
      <div className='lg:w-2/6 md:w-3/6  xl:w-1/6 w-5/6 py-8 bg-background bg-opacity-50 shadow-xl rounded-xl flex flex-col'>
        <div className='w-full mt-4'>
          <img src={Logo} alt="" className='m-auto mt-4' />
          <h2 className='text-center mt-2 font-semibold text-xl text-primary'>Bem Vindo</h2>
        </div>
        <form className='w-5/6 m-auto flex flex-col gap-4 mt-8' onSubmit={handleSubmit}>
          <input
            type="email"
            name="login"
            id="login"
            placeholder='E-mail'
            className={`w-full rounded p-2 font-semibold shadow outline-primary ${erro ? 'border-warning border': ''}`}
            value={email}
            onChange={e => setEmail(e.target.value)} />
          <div className='flex flex-col items-end'>
            <input
              type="password"
              name="pass"
              id="pass"
              placeholder='Senha'
              className={`w-full rounded p-2 font-semibold shadow outline-primary ${erro ? 'border-warning border': ''}`}
              value={pass}
              onChange={e => setPass(e.target.value)} />
            <a href="/" className='text-white'>Esqueceu sua senha</a>
          </div>
          {
            erro &&
            <div className=" text-red-700 px-4 py-3 rounded relative bg-warning " role="alert">
              <strong className="font-bold text-white">E-mail ou senha incorretos</strong>
            </div>
          }
          <input
            type='submit'
            disabled={desabilitado}
            className='p-4 bg-primary w-5/6 m-auto rounded text-white font-semibold text-xl hover:opacity-90 hover:cursor-pointer disabled:cursor-not-allowed'
            value={'Entrar'} />
        </form>
      </div>
    </div>
  )
};
